<template>
  <div class="accounts">

  <template>
  <v-card class="mt-4 mx-auto"
    min-width="550"
    max-width="910"
    :loading="loading"
    >
    <v-card-title>
    <h2 class="ma-2 subheading grey--text">{{ date_range }}</h2>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
            <v-chip label outlined>
            {{ $tocurr(sumField(accounts, 'Account')) }}
            </v-chip>
    </v-card-title>

    <v-card-text ma=4>
    <v-data-table
      :headers="headers"
      :items="filteredAcc"
      :search="search"
      sort-by="Account"
      sort-desc
      class="elevation-1"
      @click:row="clickrow"
      :loading="loading"
      loading-text="Loading... Please wait"
    >

    <template v-slot:item.Account="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.Account) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>
    </v-data-table>
      </v-card-text>
  </v-card>
</template>


  </div>
</template>

<script>

export default {
  props: {
    date_range: { required: true },
    accounts: {required: true, type: Array},
    loading: {default: true},
    search: {default: ''},
    supplier: {required: true, type: Boolean},
  },
  computed: {
    filteredAcc() {
      return this.accounts.filter(e=>e.Account>0)
    }

  },
  data() {
    return {
      balances: [{Dates: "", Balance: 0 }],
      headers: [
          { text: 'Α/Α', value: 'Holder.Id', align: 'start' },
          { text: 'Ονομα', value: 'Holder.Name', align: 'start' },
          { text: 'Υπόλοιπο', value: 'Account', align: 'end' },
        ],
    }
  },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  
    clickrow(item) {
        if (this.supplier) {
            this.$router.push({"name": 'distributor-balance', "params": { id: item.Holder.Id}})
        } else {
            this.$router.push({"name": 'customer-info', "params": { id: item.Holder.Id}})
        }
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },

  }
}
</script>


